import styled, { css } from 'styled-components';
import { Chip, ButtonV2, RadioV2 } from '@getgrover/ui';
import FrontshopLink from 'ggApp/shared/containers/FrontshopLink/index';
import DeliveryBlock from 'ggApp/shared/components/cards/ProductDetailsCard/badges/Delivery/index';
import { CardImage as ProductImage } from './CardImage';
import { Promo as PromoBlock } from './Promo';

const disabledStyles = css`
    opacity: 0.6;
    pointer-events: none;
`;

export const Container: any = styled.section`
    border-radius: 8px;
    border: 2px solid ${({ theme }) => theme.colors['Level 1']};
    padding: 16px;
    ${({ active, disabled }: { active: boolean; disabled: boolean }) => {
        if (disabled) {
            return disabledStyles;
        }
        if (!active) {
            return `
                cursor: pointer;
            `;
        }
        return undefined;
    }};
`;

export const Header = styled.div`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
`;

export const HeaderContent = styled.div`
    display: flex;
    flex-direction: column;
`;

export const HeaderTitle = styled.p`
    ${({ theme }) => theme.typography.Paragraph};
`;

export const Description = styled.p`
    ${({ theme }) => theme.typography.TinyParagraph};
`;

export const CardCheck = styled(RadioV2)`
    margin-right: 16px;
    input {
        visibility: hidden;
    }
`;

export const LabelNew = styled(Chip)`
    margin-left: auto;
    background-color: ${({ theme }) => theme.colors.Color1};
`;

export const LearnMore = styled(FrontshopLink)`
    margin-left: auto;
    ${({ theme }) => theme.typography.TinyParagraph};
    color: ${({ theme }) => theme.colors['Level 4']};
    border-bottom: 1px solid ${({ theme }) => theme.colors['Level 4']};

    &:hover {
        color: ${({ theme }) => theme.colors['Level 4']};
        border-bottom: none;
    }
`;

export const Content = styled.div`
    margin-top: 16px;
`;

export const Delivery = styled(DeliveryBlock)`
    margin-top: 16px;
`;

export const Promo = styled(PromoBlock)`
    margin-top: 16px;
`;

export const Cta = styled(ButtonV2)`
    margin-top: 16px;
`;

export const CtaText = styled.h3`
    ${({ theme }) => theme.typography.SuperTinyHeadline};
`;

export const Images = styled.div`
    display: flex;
    margin-top: 16px;
`;

export const Img = styled.div`
    position: relative;

    &:not(:first-child) {
        margin-left: 16px;
    }
`;

export const Icon = styled.div`
    position: absolute;
    bottom: -12px;
    right: -12px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: #edf0ff;
    border-radius: 50%;

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const CardImage = styled(ProductImage)<{
    active?: boolean;
    inSwap?: boolean;
}>`
    cursor: default;
    opacity: ${({ active }) => (active ? '1' : '0.5')};
    border-color: ${({ inSwap }) => inSwap && '#415FFF'};
`;
